import {combineReducers} from 'redux';
import reducer from './Reducer';

const rootReducer = combineReducers({
  apiReducer: reducer,

});

export default rootReducer;
